import { c as _c } from "react/compiler-runtime";
import { Dispatch, RefObject, SetStateAction, Suspense } from 'react';
import clsx from 'clsx';
import { useSetAtom } from 'jotai';
import { useClickOutside } from '@/hooks/useClickOutside';
import { headerPageOverlayAtom } from '@/store/atoms';
import { SearchWrapper } from '../SearchWrapper';
type MobileSearchWrapper = {
  showMobileSearch: boolean;
  setShowMobileSearch: Dispatch<SetStateAction<boolean>>;
  containerRef: RefObject<HTMLDivElement | null>;
};
export const MobileSearchWrapper = t0 => {
  const $ = _c(15);
  const {
    showMobileSearch,
    setShowMobileSearch,
    containerRef
  } = t0;
  const setShowOverlay = useSetAtom(headerPageOverlayAtom);
  let t1;
  if ($[0] !== setShowMobileSearch) {
    t1 = () => setShowMobileSearch(false);
    $[0] = setShowMobileSearch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hideMobileSearch = t1;
  useClickOutside(containerRef, hideMobileSearch);
  let t2;
  let t3;
  if ($[2] !== setShowOverlay) {
    t2 = () => setShowOverlay(true);
    t3 = () => setShowOverlay(false);
    $[2] = setShowOverlay;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  const t4 = showMobileSearch ? "visible translate-y-0 opacity-100" : "invisible -translate-y-full opacity-0";
  let t5;
  if ($[5] !== t4) {
    t5 = clsx(t4, "p-x-container absolute! top-full right-0 left-0 -z-2 w-full bg-white pb-4 duration-150 min-[834px]:hidden");
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== hideMobileSearch || $[8] !== t2 || $[9] !== t3 || $[10] !== t5) {
    t6 = <Suspense><SearchWrapper onFocus={t2} onBlur={t3} className={t5} onSearch={hideMobileSearch} /></Suspense>;
    $[7] = hideMobileSearch;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== showMobileSearch || $[13] !== t6) {
    t7 = <div data-mobile-search-expanded={showMobileSearch}>{t6}</div>;
    $[12] = showMobileSearch;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};